import { getErrorMessage } from 'application/util/error.util';

import './general.style.sass';
import template from './general.tpl.pug';

class GeneralSettingsController {
    /* @ngInject */
    constructor(profileService, preferenceService, notificationService) {
        this.profileService = profileService;
        this.preferenceService = preferenceService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.loading = true;
        this.preferences = {};

        return this.preferenceService.get().then((preferences) => {
            this.preferences = preferences;
        }, (result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to retrieve your general settings.`));
        }).finally(() => {
            this.loading = false;
        });
    }

    get autoCategorization() {
        return this.preferences && !this.preferences.autoCategorizationOff;
    }

    set autoCategorization(value) {
        if (this.preferences) {
            this.preferences.autoCategorizationOff = !value;
        }
    }

    updatePreferences() {
        return this.preferenceService.save(this.preferences).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to update your general settings.`));
        });
    }
}

export default {
    selector: 'dbAGeneralSettings',
    template: template(),
    controller: GeneralSettingsController
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/settings/scene/general/general.cmpt.js